import { Button } from '@amzn/stencil-react-components/button';
import { Col, Container, Row, Spacer } from '@amzn/stencil-react-components/layout';
import { ModalContent, WithModal } from '@amzn/stencil-react-components/modal';
import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner';
import { Text } from '@amzn/stencil-react-components/text';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { getMessageTemplateDetails } from '../../actions/nudgeActions';

import { IconExternalLinkSmall } from '@amzn/stencil-react-icons';

const TemplatePreview = ({ templateName, close }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(store => store.userInfo);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(
    () => {
      (async () => {
        setIsLoading(true);
        await dispatch(getMessageTemplateDetails(templateName.name, userInfo.idToken));
        setIsLoading(false);
      })();
    },
    [templateName.name],
  );

  const templates = useSelector(store => store.nudge.messageTemplateDetailList);
  const { messageTemplateName = '', messageHtmlPart = '' } = templates;

  const renderModal = ({ close }) => (
    <ModalContent
      titleText={messageTemplateName}
      maxWidth="720px"
      buttons={[
        <Button onClick={close} primary>
          <FormattedMessage id="app.button.done" defaultMessage="Done" />
        </Button>,
      ]}
    >
      <Container
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="row"
        padding={10}
      >
        {isLoading && <Spinner size={SpinnerSize.Large} />}
        <Col
          alignSelf="flex-start"
          dangerouslySetInnerHTML={{
            __html: messageHtmlPart?.replace(/"/i, ''),
          }}
        />
      </Container>
    </ModalContent>
  );

  return (
    <WithModal renderModal={renderModal}>
      {({ open }) => (
        <Row display="flex" justifyContent="start">
          <Button tertiary data-testid="preview-modal-button" onClick={open}>
            <Text>{messageTemplateName}</Text>
            <Spacer width={10} />
            <IconExternalLinkSmall color="primary70" />
          </Button>
        </Row>
      )}
    </WithModal>
  );
};

export default TemplatePreview;
